export default __webpack_public_path__ + "static/media/SGP.8e2d1cc7.svg";